import { posterMap } from "@/pages/poster/js/poster-long-static";
import { findItemByBlockName, genPosterBlock, initPosterTextMaps } from "../../pages/poster/js/poster-struct";
export const posterLong = {
  namespaced: true,
  state: {
    // 海报数据
    posterData: JSON.parse(JSON.stringify(posterMap)),
    // 海报文字数据
    posterTextMaps: initPosterTextMaps(),
    // 当前操作的模块
    currentBlock: "",
  },
  mutations: {
    // 更新posterData
    updatePosterData (state, map) {
      if (map.params && map.data) {
        Object.assign(map.data, map.params);
        return;
      }
      Object.assign(state.posterData, map);
    },
    // 更新posterTextMaps
    updatePosterTextMaps (state, map) {
      if (map.params && map.data) {
        Object.assign(map.data, map.params);
        return;
      }
      state.posterTextMaps = map;
    },
    // 更新当前操作的模块
    updateCurrentBlock (state, block) {
      state.currentBlock = block;
    },
    // 海报模块新增一条文本
    addItemToPosterBlock (state, { items, blockName }) {
      const item = findItemByBlockName(blockName);
      if (blockName === "normalImgText") {
        item.content.labelStyle = items[0].content.labelStyle;
      }
      item && items.push(item);
    },
    // 删除海报模块的一条文本
    removeItemFromPosterBlock (state, { items, index }) {
      items.splice(index, 1);
    },
    // 删除海报模块的某个模块
    removeBlockFromPosterBlock (state, { index }) {
      state.posterTextMaps.splice(index, 1);
    },
    // 添加一个模块
    addBlockToPosterBlock (state, { blockName }) {
      state.posterTextMaps.splice(-1, 0, genPosterBlock(blockName));
    },
    // 移动模块
    movePosterBlock (state, { originIndex, targetIndex }) {
      const posterBlock = state.posterTextMaps[originIndex];
      state.posterTextMaps.splice(originIndex, 1);
      state.posterTextMaps.splice(targetIndex, 0, posterBlock);
    },
    // 清除缓存的数据
    clearPosterCacheInfo (state) {
      state.posterData = JSON.parse(JSON.stringify(posterMap));
      state.posterTextMaps = initPosterTextMaps()
      state.currentBlock = ''
    },
  },
};
